// extracted by mini-css-extract-plugin
export default {"container":"Document_container__WHYmz","content":"Document_content__tS8QX","button":"Document_button__R4cZQ"};